// extracted by mini-css-extract-plugin
module.exports =  {"header":"O8Ko75vB","subheader":"nbhw32JU","buttons":"NKQR9Wzy"};